'use strict';

export default function routes($stateProvider) 
{
	'ngInject';

	//console.log("Importing champs:routes");
	
	$stateProvider
		.state('champs', {
			url: '/cr',
			params: null,
			template: require('./champs.html'),
			controller: 'ChampsController',
			controllerAs: 'vm'
		})
		.state("Champ", {
			url: "/ch/{champ:int}",
			template: require('./champ.html'),
			controller: "ChampController",
			controllerAs: 'vm'
		})
		.state("Champ2", {
			url: "/ch/{champ:int}/{category:int}",
			template: require('./champ.html'),
			controller: "ChampController",
			controllerAs: 'vm'
		});
}



// WEBPACK FOOTER //
// ./client/app/frontend/champs/champs.routes.js